import React , {useEffect , useState , useContext} from 'react'
import "./coupons.css";
import CouponItems from './CouponItems';
import {AiFillCloseCircle} from "react-icons/ai";
import UserContext from '../../../../context/user_context';
import {db, firestoreDB} from "../../../../config/firebase_config.js" ;
import { ref ,query, equalTo ,get  , orderByKey, limitToLast ,orderByChild} from '@firebase/database';
import { collection, getDocs, query as fsQuery, where } from 'firebase/firestore';
import { LoadingSpinner } from '../../../../components/mini-components/mini-components';
import CustomOffers  from "../../../../models/custom_offers.js" 
import CartContext from '../../../../context/cart_context.js';


const CouponsSheet = ({setShowCoupons , setShowValidCoupon , setSelectedCoupon }) => {

  const { selectedRest:currentRest} = useContext(CartContext);
 const [couponsList, setCouponsList] = useState([]);
 const [loading, setLoading] = useState(false);

 const {userInfo} = useContext(UserContext);


 const getCouponsData = async ()  => {
    let customOffers = [];
    try {

      console.log("run avtunda yetti");
      setLoading(true);

      const databaseRef = ref( db, "Offers&Coupons");
      const snapshot = await get(databaseRef);
      if (snapshot.exists()) {
        const couponData = snapshot.val();
        Object.entries(couponData).forEach(([key, value]) => {
          const off = CustomOffers.fromJson(key, value);
          if (off.status === "ACTIVE" && off.visibility == "YES" && off.priority === "Yes" ) {
            customOffers.push(off);
          }
        });
      }

  
      const myOffersRef = ref(db, `MyOffers&Coupons/${userInfo.phoneNo}`);
      // const filteredQuery = query(myOffersRef, equalTo("phoneNo", userInfo.phoneNo ));
      const myOffersSnap = await get(myOffersRef);
      if(myOffersSnap.exists()){
        const myOffersCoup = myOffersSnap.val();
        Object.entries(myOffersCoup).forEach(([key, value]) => {
            const off = CustomOffers.fromJson(key, value);
            if (off.status === "ACTIVE" && off.visibility == "YES"&& off.priority === "Yes" ) {
              customOffers.push(off);
            }
          });
      }

    console.log(userInfo);
     const domain = userInfo.emailId.split("@")[1];
     console.log("domain id : " ,domain);
      if(userInfo.emailId.length > 5 && domain && domain != "gmail.com"  ){
         const orgOfferSnap = await get(query(ref(db , "organisation_coupons") ,  orderByChild('domainId'), equalTo(domain) ));
         if(orgOfferSnap.exists()){
            let orgOffers = [];
            const orgOfferData = orgOfferSnap.val();
            console.log(orgOfferData);
            Object.entries(orgOfferData).forEach(([key, value]) => {
                console.log({value});
                const off = CustomOffers.fromJson(key, value);
                console.log(off);
                if (off.status === "ACTIVE" && off.visibility == "YES" ) {
                  orgOffers.push(off);
                }
            });
            console.log({orgOffers});
            if(orgOffers.length > 0 ){

              if(currentRest.isSubStore == "No" && currentRest.subStores == "No"){
                  orgOffers.forEach((val) => {
                    if( currentRest.dbID == val.mainStoreId ){
                        customOffers.push(val);
                    }
                  })
              }

              if(currentRest.isSubStore == "Yes" ){

                  for(let off of [...orgOffers] ){
                    const checkStoreSnap = await get(ref(db , `${off.mainStoreId}_SubStores/${currentRest.dbID}`));
                    if(checkStoreSnap.exists()){
                      customOffers.push(off);
                    }
                  }

              }
          }

         }


      }



      const selectedRest = JSON.parse(localStorage.getItem("selected-rest"));
      const restRef = ref(db, `${selectedRest.dbID}_Offers&Coupons`);
      const restSnap = await get(restRef);
      if(restSnap.exists()){
        const restCoup = restSnap.val();
        Object.entries(restCoup).forEach(([key, value]) => {
            const off = CustomOffers.fromJson(key, value);
            if (off.status === "ACTIVE" && off.visibility == "YES" && off.priority === "Yes") {
              customOffers.push(off);
            }
          });
      }


      // Vendor "Offers" (Firestore -> StoreOffers) for online ordering. These
      // are stored separately from the RTDB coupons above, so without this they
      // never appear in the checkout. Only ONLINE_ORDER / BOTH offers apply here.
      try {
        const storeIdCandidates = [
          currentRest?.dbID,
          currentRest?.mainStoreId,
          currentRest?.storeId,
        ].filter(Boolean);
        const storeIds = [...new Set(storeIdCandidates)];

        if (storeIds.length > 0) {
          const offersSnap = await getDocs(
            fsQuery(collection(firestoreDB, "StoreOffers"), where("restId", "in", storeIds))
          );
          offersSnap.forEach((docSnap) => {
            const data = docSnap.data();
            const isActive = data.isActive === true || data.isActive === "true" || data.isActive === 1;
            const type = (data.type || "").toString().toUpperCase();
            if (isActive && (type === "ONLINE_ORDER" || type === "BOTH")) {
              // Map a StoreOffer into the coupon shape CouponItems expects.
              customOffers.push({
                dbID: docSnap.id,
                couponCode: data.offerCode,
                offerTitle: data.title,
                offerDescription: data.description,
                discount: data.discount,
                minimumOrderValue: data.minimumOrderValue,
                maximumDiscountValue: data.maximumDiscountValue,
                status: "ACTIVE",
                visibility: "YES",
              });
            }
          });
        }
      } catch (e) {
        console.log("StoreOffers fetch error", e);
      }

      console.log(customOffers);
      for(let off of [...customOffers] ){
        if(off.isFirstOrder == "Yes"){
        const userPayHistory = ref(db , `${userInfo.phoneNo}_ConfirmPayment` );
        const myOffersSnap = await get(query(userPayHistory, orderByKey(), limitToLast(1)));
        //  get(userPayHistory);
        if(myOffersSnap.exists()){
          console.log("<-------------->");
          // console.log(off);
          console.log(myOffersSnap);
          console.log("<-------------->");
          customOffers = customOffers.filter((offer) => offer.dbID != off.dbID );
        }
      }
    }

      setCouponsList(customOffers);
      setLoading(false);

      
    } catch (e) {
      console.log(e);
        setLoading(false);
    }
  
    return customOffers;
  }
  

    useEffect(() => {
       document.body.style.overflowY = "hidden";
       getCouponsData();
        return () => {
            document.body.style.overflowY = "scroll"; 
        }
    }, [])


  return (
    <div className='coupon-bottom-bg' >
        <div className='coupon-bottom-container' >
            <div className='coupon-title'>
                <h3>Available Coupons</h3>
                <span onClick={() => {
                     setShowCoupons(false) ;
                     }} > <AiFillCloseCircle/></span>
            </div>
            <div className='coupon-items-list'>
                {
                    loading
                  ? <LoadingSpinner/> 
                  : (
                    couponsList.map( (coupon , index) => {
                        return <CouponItems coupon={coupon} key={index}  setShowValidCoupon={setShowValidCoupon}  setShowCoupons={setShowCoupons} setSelectedCoupon={setSelectedCoupon} />
                    } )
                  )
                    
                  
                }
            </div>
        </div>
  </div>
  )
}

export default CouponsSheet